import styled from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

export const LOGO_WIDTH = 64;
export const LOGO_HEIGHT = 42;
const BOLT_LOGO_WIDTH = 35;
const BOLT_LOGO_HEIGHT = 15;

export const Container = styled.div<{ slaBgColor?: string }>(({ slaBgColor, theme }) => ({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingLeft: theme.spacing.small,
    background: slaBgColor
        ? slaBgColor
        : "linear-gradient(89deg, rgba(245, 245, 250, 0.8) -0.28%, rgba(245, 245, 250, 0.4) 82.93%, rgba(255, 255, 255, 0.66) 99.47%)",
    opacity: 0.8,
    borderRadius: theme.cornerRadius.xSmall,
}));

export const LogoWrapper = styled.div`
    max-height: ${LOGO_HEIGHT}px;
`;

export const SlaTextWrapper = styled(Text)(({ theme }) => ({
    padding: `${theme.spacing.xSmall}  0`,

    div: {
        display: "block",
    },
    "div span::before": {
        content: '""',
        display: "inline-block",
        width: "2px",
    },
    "& .imageStyle": {
        height: `${BOLT_LOGO_HEIGHT}px`,
        width: `${BOLT_LOGO_WIDTH}px`,
        verticalAlign: "sub",
    },
}));
